// 主页接口
import http from '../request.js'

export default {
  list: (data) => {
    return http({
      url: '/api/integral_product/evaluate/list',
      data
    })
  },

  save: (data) => {
    return http({
      url: '/api/integral_product/evaluate/save',
      data
    })
  },

  del: (data) => {
    return http({
      url: '/api/integral_product/evaluate/del',
      data
    })
  }
}
